const { query: queryGraphql } = require('./src/graphql');
const introspectionApi = require('./src/introspectionApi');
const queryApi = require('./src/queryApi');
const queryHelper = require('./src/queryHelper');
const VersionMap = require('./src/VersionMap');

module.exports.introspectionApi = introspectionApi;
module.exports.queryGraphql = queryGraphql;
module.exports.queryApi = queryApi;
module.exports.queryHelper = queryHelper;
module.exports.VersionMap =	VersionMap;